import React, { useState, useEffect } from "react";
import Checkbox from '../checkbox'
import {
    Button, Box, ListItem, List, ListItemText, useMediaQuery
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { useDataProvider } from 'react-admin';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Error } from 'react-admin';
import { Edit, useTranslate } from 'react-admin';
import IconTitle from './TitleRole';
import SubItem from '../role/GroupItem';
import { grey } from '@material-ui/core/colors';
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AppState } from '../types';
import { isBlocking } from '../role/actions';
import { useDispatch } from 'react-redux';
import { shouldBeDisabled } from '../utils';
import DialogAlertSave from '../common/dialog-alert-save';
import { LoadingButton } from '../common/button';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        Container: {
            width: '800px'
        },
        table: {
            minWidth: 650,
        },
        Button: {
        },
        Card: {
            marginTop: '2em',
            padding: '1em'
        },
        buttonProgress: {
            color: 'blue',
            position: 'absolute',
            left: 23,
            top: 5
        },
        name: {
            width: '25em',
            minWidth: '25em',
            maxWidth: '25em',
            wordBreak: 'break-all'
        },
        tableCell: {
            borderBottom: 'solid 5px ' + theme.palette.background.default
        },
        expandText: {
            fontSize: 10,
            fontWeight: 'bold',
            color: grey[500]
        }, expandGroup: {
            width: 150,
            height: 30,
            float: 'right',
            backgroundColor: theme.palette.common.white,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around'
        },
        TextRole: {
            fontFamily: 'UniviaPro-Book',
            fontSize: '13px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 'normal',
            letterSpacing: 'normal',
            color: '#4f5064',
            paddingLeft: 20,
        },
        btnCancel: {
            fontFamily: 'UniviaPro',
            fontSize: '10px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.25,
            letterSpacing: '0.4px',
            color: '#237fc2',
        },
        btnSave: {
            fontFamily: 'UniviaPro-Bold',
            fontSize: '11px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 'normal',
            letterSpacing: '0.44px',
            color: '#ffffff',
        },
    }),

);


const RoleEditTitle = ({ record }: any) => {
    return <span>Role {record ? `"${record.name}"` : ''}</span>;
};

const FunctionContainer = ({ list, onChangeFunction }: any) => {
    const classes = useStyles();
    const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.down('md'));
    return (
        <Box display='flex' width='100%'>
            <Box width='100%'>
                {
                    list.map((item: any, index: any) => (
                        <ListItem key={index} className={classes.tableCell}>
                            <ListItemText primary={<Typography className={classes.TextRole}>{item.functionName}</Typography>} />
                            <Box display="flex" style={{ alignItems: "center" }} width='79px' mr={isDesktop ? 10 : '86px'}>
                                <Checkbox
                                    disabled={item.disable}
                                    id={item.id + 'isCreate'}
                                    checked={item.isCreate}
                                    style={{ marginLeft: '6px' }}
                                    size="medium"
                                    onChange={() => onChangeFunction(item, 'EDIT')}
                                />
                            </Box>
                            <Box display="flex" style={{ alignItems: "center" }} width='79px' mr={isDesktop ? 10 : '85px'}>
                                <Checkbox
                                    disabled={item.isCreate === true}
                                    id={item.id + '-read'}
                                    checked={item.isRead}
                                    style={{ marginLeft: '6px' }}
                                    onChange={() => onChangeFunction(item, 'READ')}
                                />
                            </Box>
                        </ListItem>
                    ))
                }
            </Box>
        </Box>

    );
}

const GroupContainer = ({ entity, onToggleExpand, onUpdateEntities, index, onChangeFunction }: any) => {
    const dispatch = useDispatch();
    const onChangeEntites = (type: string) => {
        dispatch(isBlocking(true))
        // dispatch(changeRole(true))

        const entityIsRead = type === 'READ' ? !entity.isRead : entity.isRead;
        const entittyIsCreate = type === 'EDIT' ? !entity.isCreate : entity.isCreate;
        const newEntity = {
            ...entity,
            isRead: entityIsRead,
            isCreate: entittyIsCreate,
            functions: entity.functions.map((func: any) => {
                const isRead = type === 'READ' ? entityIsRead : func.isRead ? func.isRead : !entity.isCreate;
                const isCreate = type === 'EDIT' ? entittyIsCreate : func.isCreate;
                return {
                    ...func,
                    isRead,
                    isCreate,
                    disable: (func.functionId === 27 && entittyIsCreate || func.functionId === 25 && entittyIsCreate)
                };

            })
        };
        onUpdateEntities(newEntity, index);
    }

    return (
        <Box display="flex" width='100%' justifyContent='center'>
            <Box width='700px' my={2}>
                <SubItem
                    groupData={entity}
                    countCluster={0}
                    onToggleExpand={onToggleExpand}
                    onChange={onChangeEntites}
                >
                    <List component="div" disablePadding>
                        <FunctionContainer list={entity['functions']} onChangeFunction={onChangeFunction} />
                    </List>
                </SubItem>
            </Box>
        </Box>
    );
}
const RoleEditContainer = (props: any) => {
    const dataProvider = useDataProvider();
    const [expandAll, setExpandAll] = useState(false);
    const [entities, setEntities] = useState([]);
    const [error, setError] = useState();
    const [loading, setLoading] = useState(true);
    let roleId = props.record['id'];
    const classes = useStyles();
    const translate = useTranslate();
    const history = useHistory();
    let is_blocking = useSelector((state: AppState) => state.is_blocking);
    const dispatch = useDispatch();

    useEffect(() => {
        dataProvider('GET_ONE', "FunctionActions/Roles", {
            id: roleId
        }).then(({ data }: any) => {
            const group = data.groups.map((datagroup: any) => {
                const functions = datagroup.functions.map((cls: any) => {
                    if (cls.functionId === 25 || cls.functionId === 27) {
                        return {
                            ...cls,
                            disable: shouldBeDisabled(cls)
                        }
                    }
                    else {
                        return {
                            ...cls,
                            disable: false
                        }
                    }
                });
                console.log(functions, 'functions')
                return {

                    ...datagroup,
                    functions,
                    expand: false,
                    isAllCreate: false,
                    isAllRead: false,
                }
            });
            setEntities(group);
            setLoading(false);
        }).catch((error: any) => {
            setLoading(false);
            setError(error);
        });
    }, []);
    // if (loading) return (<Loading />);
    if (error) return (<Error />);
    if (entities.length === 0) return null;
    const onExpandAllChanged = () => {
        const newgroup = entities.map((datagroup: any) => {
            return {
                ...datagroup,
                expand: !expandAll

            }
        }) as any;
        setEntities(newgroup);
        setExpandAll(!expandAll);

    }
    const onToggleExpand = (node: any) => {
        node.expand = !node.expand;
        const newEntities = entities.map((item: any) => item) as any;
        const index = entities.findIndex((entity: any) => entity.id === node.id)
        if (index !== -1) {
            newEntities[index] = node;
        }
        setEntities(newEntities);
    }


    const onChangeFunction = (func: any, type: string) => {
        dispatch(isBlocking(true))
        // dispatch(changeRole(true))
        let checkclusterInfoPageAdmin = false
        const newEntities: any = entities.map((item: any) => {
            const funcs = item.functions.map((funct: any) => {
                if (funct.id === func.id) {
                    const isCreate = type === 'EDIT' ? !funct.isCreate : funct.isCreate;
                    const isRead = type === 'READ' ? !funct.isRead : (!funct.isCreate ? !funct.isCreate : funct.isRead);
                    return {
                        ...funct,
                        isCreate,
                        isRead,
                    }
                }
                return funct;
            });
            // Return func with id 24
            const sysData = funcs.find((item: any) => item.functionId === 24);
            const log = funcs.find((item: any) => item.functionId === 25);
            const adminUser = funcs.find((item: any) => item.functionId === 26);
            const adminFunc = funcs.find((item: any) => item.functionId === 27);
            const clusterInfoPageAdmin = funcs.find((item: any) => item.functionId === 13);
            const infoPageAdmin = funcs.find((item: any) => item.functionId === 18);
            if (clusterInfoPageAdmin && clusterInfoPageAdmin.isCreate === true) {
                checkclusterInfoPageAdmin = true
            }
            if (checkclusterInfoPageAdmin === true) {
                if (infoPageAdmin) {
                    infoPageAdmin.isRead = true
                }
            }
            if (sysData !== undefined && sysData.isCreate === true) {
                // Check 25
                // Find id 25
                if (log !== undefined) {
                    log.isCreate = true
                    log.disable = true
                    log.isRead = true
                }

            }
            else {
                if (log !== undefined) {
                    log.disable = false
                }
            }

            if (adminUser !== undefined && adminUser.isCreate === true) {
                // Find id 27
                // Check 27
                if (adminFunc !== undefined) {
                    adminFunc.isCreate = true
                    adminFunc.disable = true
                    adminFunc.isRead = true
                }


            } else {
                if (adminFunc !== undefined) {
                    adminFunc.disable = false
                }
            }

            for (let i = 0; i < funcs.length; i++) {
                if (funcs.id === 25) {
                    funcs[i] = log;
                }
                else if (funcs.id === 27) {
                    funcs[i] = adminFunc;
                }
                if (funcs.id === 13) {
                    funcs[i] = clusterInfoPageAdmin;
                }
                if (funcs.id === 18) {
                    funcs[i] = infoPageAdmin;
                }
            }
            return {
                ...item,
                functions: funcs
            };
        });
        setEntities(newEntities);

    }


    const onSave = () => {
        is_blocking = false;
        dispatch(isBlocking(is_blocking))
        let updateActions = [] as Array<any>;
        setLoading(true)
        entities.forEach((element: any, index: any) => {
            element.functions.forEach((func: any, index: any) => {
                updateActions.push((dataProvider('UPDATE', 'FunctionActions', { id: func.id, data: func })));
            })
        });

        Promise
            .all(updateActions)
            .then((responses) => {
                history.push({
                    pathname: '/roles',
                    state: { open: "true", name: props.record['name'] }
                });
                setLoading(false);
            })
            .catch((ex) => {
                setLoading(false);
            })
    }

    const onSaveConfirm = (cb: any) => {
        let updateActions = [] as Array<any>;
        entities.forEach((element: any, index: any) => {
            element.functions.forEach((func: any, index: any) => {
                updateActions.push((dataProvider('UPDATE', 'FunctionActions', { id: func.id, data: func })));
            })
        });
        Promise.all(updateActions).then((responses) => {
            // history.push({
            //     pathname: '/roles',
            //     state: { open: "true", name: props.record['name'] }
            // });
        }).catch((error) => {
            console.error('ON SAVE ERROR:', error)
        }).finally(cb)
    }

    const onUpdateEntities = (entity: any, index: number) => {
        const newEntities: any = entities.map((item: any, idx: number) => {
            if (index === idx) {
                return entity;
            }
            return item;
        });
        setEntities(newEntities);
    }

    return (
        <DialogAlertSave onSave={onSaveConfirm}>
            <Box width='95%' m='auto'>
                <Box display='flex'>
                    <IconTitle
                        TitleBack={translate(`resources.role.back`)}
                        TitleName={props.record['name']}
                        onExpandAllChanged={(): any => onExpandAllChanged()}
                        expandAll={expandAll}
                    />
                </Box>

                {
                    entities.map((entitiy: any, index: number) =>
                        <GroupContainer entity={entitiy} key={entitiy.id} onUpdateEntities={onUpdateEntities} index={index}
                            onToggleExpand={onToggleExpand} onChangeFunction={onChangeFunction}
                        />
                    )
                }

                <Box display="flex" width='100%' justifyContent='center'>
                    <Box style={{ width: "700px", display: 'flex' }}>
                        <Box marginLeft='auto'>
                            <Button
                                style={{ marginTop: "2em", marginRight: '30px' }}
                                component={Link}
                                to={{ pathname: "/roles" }}
                            >
                                <Typography className={classes.btnCancel}>{translate(`pos.dashboard.CANCEL`)}</Typography>
                            </Button>
                            <LoadingButton
                                loading={loading}
                                label={translate(`resources.role.Save`)}
                                onClick={onSave}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </DialogAlertSave>
    );
}

const RoleEdit = (props: any) => {


    return (
        <Edit component="div" {...props}
            title={<RoleEditTitle />}

        // actions={< RoleEditActions />}
        >

            <RoleEditContainer {...props} />
        </Edit>
    );
};

export default RoleEdit;
